export default function Popconfirm() {
  return {}
}
